var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75C24.3098 3.75 28.443 5.46205 31.4905 8.50951C34.538 11.557 36.25 15.6902 36.25 20C36.25 24.3098 34.538 28.443 31.4905 31.4905C28.443 34.538 24.3098 36.25 20 36.25C15.6902 36.25 11.557 34.538 8.50951 31.4905C5.46205 28.443 3.75 24.3098 3.75 20C3.75 15.6902 5.46205 11.557 8.50951 8.50951C11.557 5.46205 15.6902 3.75 20 3.75ZM20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40ZM28.8281 16.3281C29.5625 15.5938 29.5625 14.4063 28.8281 13.6797C28.0938 12.9531 26.9063 12.9453 26.1797 13.6797L17.5078 22.3516L13.8359 18.6797C13.1016 17.9453 11.9141 17.9453 11.1875 18.6797C10.4609 19.4141 10.4531 20.6016 11.1875 21.3281L16.1875 26.3281C16.9219 27.0625 18.1094 27.0625 18.8359 26.3281L28.8281 16.3281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckwhite);
export default __webpack_public_path__ + "static/media/circle-check white.d3cda42550d74e7f16f1030a95f68ba4.svg";
export { ForwardRef as ReactComponent };